export default class Region {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        regionRetrieve(id: ${id}) {
          id
          name
          country {
            id
            name
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.regionRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        regionList {
          results {
            id
            name
            country {
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.regionList.results.reverse();
  }

  static async filter(axios, country) {
    const response = await axios.post(
      '/graphql/',
      `query{
        regionList (country: ${country}){
          results {
            id
            name
            country {
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.regionList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteRegion(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteRegion.ok;
  }

  static async create(axios, name, country) {
    const countryField = (country > 0) ? `country: ${country},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        createRegion(newRegion: {
          ${countryField}
          name: "${name}", 
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createRegion.ok;
  }


  static async edit(axios, id, name, country) {
    const countryField = (country > 0) ? `country: ${country},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateRegion(newRegion: {
          ${countryField}
          id: ${id},
          name: "${name}", 
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateRegion.ok;
  }


}